import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import locale from './modules/locale';
import user from './modules/user';
import public_data from '@store/public_data';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        locale,
        user,
        public_data
    }
});
